/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import useOutsideClick from "../clickOutSide";
import { useSidebarContext } from "../../Contexts/SidebarContext";

//switch user dialogue
import SwitchOrganization from "./switchuserdialog";
import ChangePassword from "./changepassworddialog";
import BreadCrumps from "./BreadCrumps";
import ImageLoader from "../parkinglotComponent/ImageLoader";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { showToast } from "../../utils/tools";
import ProfileDialog from "./profiledialog";
import { getMessageText, setLanguage } from "../../utils/message";
import * as LangConst from "../../utils/constant/LangConst";
import { LocalStorageUtil } from "../../utils/LocalStorageUtil";
import { reDirectURLTo, handleLogout } from "../../utils/redirectionUtil";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedInternalOrg } from "../../reducers/organizationSlice";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import * as actionTypes from "./../../store/actions/actions";
// @ts-ignore
import useDataLayer from "../hooks/UserTagManagerHook";

let orgFirstKey = "";
let orgName = "";

dayjs.extend(utc);
export default function Navbar() {
  const {
    openSidebar,
    sideBar,
    user,
    setCountryCodes,
    selectedLanguage,
    language,
    loginId,
    loginUser,
  } = useSidebarContext();
  const navigate = useNavigate();
  const location = useLocation();
  const pushToDataLayer = useDataLayer();
  useEffect(() => {
    pushToDataLayer({
      event: "user_login",
      user_id: String(LocalStorageUtil.getItem("loggedInSaasOrgId")),
      user_name: loginUser || String(LocalStorageUtil.getItem("user")),
      user_role: JSON.parse(LocalStorageUtil.getItem("role")) || "srini",
    });
  }, []);

  useEffect(() => {
    LocalStorageUtil.setItem("finparkLastViewedPage", location?.pathname);
    loadServerandKeys();

    pushToDataLayer({
      event: "page_view",
      user_id: String(LocalStorageUtil.getItem("loggedInSaasOrgId")),
      page_title: document.title,
      page_path: location.pathname,
    });
  }, [location?.pathname]);

  const loadServerandKeys = async () => {
    let mili = new Date().getTime();
    const res = await axios.get(`../server.json?rand=${mili}`);
    try {
      setCountryCodes(
        res.data.servers.server.USPassCode,
        res.data.servers.server.CanadaPassCode
      );
    } catch (e) {
      console.log(e);
    }
  };

  const selectedInternalOrg = useSelector((state: any) => state?.organization?.selectedInternalOrg);

  if (
    location.pathname !== "/finparkRegistration" &&
    location.pathname !== "/globaldashboard" &&
    location.pathname !== "/SignUpPage"
  )
    return (
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box">
              <Link to="/mapDashboard" className="logo logo-dark">
                <span className="logo-sm">
                  <img
                    src="../../assets/images/logo-sm.png"
                    alt="logo-sm"
                    height="36"
                  />
                </span>
                <span className="logo-lg">
                  <img
                    src="../../assets/images/logo-dark.png"
                    alt="logo-dark"
                    height="36"
                  />
                </span>
              </Link>
            </div>
            <button
              style={{ color: "black" }}
              type="button"
              className="btn btn-sm px-3 font-size-24 header-item"
              id="vertical-menu-btn"
              onClick={(e) => openSidebar()}
            >
              <i className="ri-menu-2-line align-middle"></i>
            </button>
            <div className="ms-0 head-page-title header-item font-size-12 d-none d-sm-none d-md-block d-lg-block d-xl-block ms-xl-4">
              <div className="page-title-right">
                <BreadCrumps />
              </div>
            </div>
          </div>
          <div className="d-flex align-items-center">
          {selectedInternalOrg == "1" && (
            <button className="btn btn-primary"
                onClick={() => navigate("/finai")}
                style={{
                  border: "none",
                  background: "none",
                  // cursor: "pointer",
                }}
                title="Finpark AI Chatbot"
              >
              <img src="/assets/images/finpark_aichatbot.svg" alt="FinAI" />
              
            {/*<div
              style={{
                display: "inline-flex",
                borderRadius: "10px",
                justifyContent: "flex-center",
                textAlign: "center",
                background: "rgba(0, 0, 0, 0.03)",
                border: "1px solid rgba(0, 0, 0, 0.01)",
                width: "90px",
                alignSelf: "center",
                position: "absolute",
                right: "20%",
              }}
            >
              <button
                onClick={() => navigate("/finai")}
                style={{
                  border: "none",
                  background: "none",
                  cursor: "pointer",
                }}
              >
                
                 <svg
                  width="35"
                  height="35"
                  viewBox="0 0 55 55"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill="#4A90E2"
                    d="M18 4h28c3.3 0 6 2.7 6 6v22c0 3.3-2.7 6-6 6H26l-10 8v-8h-2c-3.3 0-6-2.7-6-6V10c0-3.3 2.7-6 6-6z"
                  />
                  <path
                    fill="#FFFFFF"
                    d="M21 18c0-1.7 1.3-3 3-3s3 1.3 3 3-1.3 3-3 3-3-1.3-3-3zM37 18c0-1.7 1.3-3 3-3s3 1.3 3 3-1.3 3-3 3-3-1.3-3-3z"
                  />
                </svg>
                <span
                  style={{
                    color: "#4A90E2",
                    fontSize: "1.2rem",
                    fontFamily: "fantasy",
                    fontWeight: "lighter",
                  }}
                >
                  FinAi
                </span> 
              </button>
            </div>*/}
          </button>)}
          <div className="topnav-right">
            <UserSettings locations={location?.pathname} />
          </div>
          </div>
        </div>
        {/* <SideDrawer /> */}
      </header>
    );
  return <></>;
}

export const OrgImage = React.memo((props: any) => {
  const dispatch = useDispatch();
  const [imageURL, setImageURL] = useState("");
  const api = useAxiosPrivate();
  const { user, imageurl, changeOrgType, setisOrgNetworkConfigEnabled } =
    useSidebarContext();
  const getOrganizationDetails = async () => {
    const saasOrgId: any = LocalStorageUtil.getItem("saasOrgId") || "";
    try {
      const { data } = await api.get(
        `/api/organization/${JSON.parse(saasOrgId)}`
      );
      changeOrgType(data?.usageType);
      setisOrgNetworkConfigEnabled(data.isOrgNetworkConfigEnabled);
      LocalStorageUtil.setItem("orgStatus", data.status);
      LocalStorageUtil.setItem("isApproved", data.isOrgApproved);
      const newKey: any = window.sessionStorage.getItem("user");
      const localItems: any = localStorage.getItem(newKey);
      const localData: any = JSON.parse(localItems);
      const pageUpdate = {
        ...localData,
        orgStatus: data.status,
      };
      window.sessionStorage.setItem("local", JSON.stringify(pageUpdate));
      let selectedInternalOrg = LocalStorageUtil.getItem("saasOrgId");
      try {
        selectedInternalOrg =
          JSON.parse(LocalStorageUtil.getItem("selectedInternalOrg")) ||
          JSON.parse(LocalStorageUtil.getItem("saasOrgId"));
      } catch (e) {
        selectedInternalOrg = LocalStorageUtil.getItem("saasOrgId");
      }
      dispatch(setSelectedInternalOrg(selectedInternalOrg));
      setImageURL(data.logoPath);
    } catch (error) {
      showToast(
        "ERROR",
        getMessageText(LangConst.ERROR_RETRIEVING_DATA, "Error retrieving data")
      );
    }
  };

  useEffect(() => {
    getOrganizationDetails();
  }, [user, imageurl]);

  if (props?.noImage && !imageURL) return <> </>;

  return (
    <ImageLoader
      styleObject={props?.styleObject ? props?.styleObject : {}}
      path={imageURL}
      className={
        props?.className ? props?.className : "rounded-3 header-profile-user"
      }
      notFoundImg="./../assets/images/noProfile.png"
    />
  );
});

const UserSettings = ({ locations }: any) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState("hide");
  const [openSwitch, setOpenSwitch] = useState(false);
  const [openChangePassword, setOpenChangePassword] = useState(false);
  const [openProfile, setOpenProfile] = useState(false);
  const [languages, setLanguages] = React.useState([
    "English",
    "French",
    "Spanish",
  ]);
  const [isLangDropDrown, setIsLangDropDrown] = useState(false);
  const [orgByUserData, setOrgByUserData] = useState([]);
  const userId = LocalStorageUtil.getItem("userId");
  const {
    username,
    userFirstName,
    userLastName,
    changeLanguage,
    selectedLanguage,
    language,
  } = useSidebarContext();
  const api = useAxiosPrivate();
  const wrapper = useRef(null);
  const navigate = useNavigate();
  const saasOrgId: any = LocalStorageUtil.getItem("loggedInSaasOrgId") || "";

  useOutsideClick(wrapper, () => {
    if (open === "show") setOpen("hide");
    if (isLangDropDrown === true) setIsLangDropDrown(false);
  });
  const onSwitchUser = (e: any) => {
    e.preventDefault();
    setOpenSwitch(true);
  };

  const onChangePassword = () => {
    setOpenChangePassword(true);
  };

  const onClickProfile = () => {
    setOpenProfile(true);
  };

  const onHandleClose = (e: any) => {
    setOpenChangePassword(false);
    setOpenSwitch(false);
    setOpenProfile(false);
  };

  // useEffect(() => {
  //   updateLocalData();
  // }, [locations]);

  useEffect(() => {
    if (saasOrgId !== "1") {
      getOrgByUser();
      document.removeEventListener("visibilitychange", handleActivityFalse);
      document.addEventListener("visibilitychange", handleActivityFalse);
      return () => {
        document.removeEventListener("visibilitychange", handleActivityFalse);
      };
    }
  }, [saasOrgId]);

  const updateLocalData = () => {
    const newKey: any = window.sessionStorage.getItem("user");
    const localData: any = window.sessionStorage.getItem("local");
    if (localData) {
      const update = JSON.parse(localData);
      const pageUpdate = {
        ...update,
        finparkLastViewedPage: locations ? locations : "/mapDashboard",
      };
      localStorage.setItem("lastLoginKey", newKey);
      window.sessionStorage.setItem("local", JSON.stringify(pageUpdate));
    }
  };

  const handleActivityFalse = () => {
    if (!document.hidden) {
      updateLocalData();
    } else {
      const newKey: any = window.sessionStorage.getItem("user");
    }
  };

  const localLang = JSON.parse(String(LocalStorageUtil.getItem("language")));

  useEffect(() => {
    if (localLang) {
      handleLanguageChange(localLang);
    }
  }, [language]);

  const handleLanguageChange = (lang: string) => {
    //const newLanguages = languages.filter((language) => language !== lang);
    //newLanguages.push(lang);
    changeLanguage(lang);
    setIsLangDropDrown(false);
  };

  const getOrgByUser = async () => {
    try {
      const { data } = await api.get(
        `/api/organization/getOrgByUser?userId=${userId}`
      );
      if (data) {
        const uniqueData = data
          ?.filter(
            (org: any, index: number, self: any) =>
              self.findIndex((item: any) => item.orgId === org.orgId) === index
          )
          .map((item: any) => ({
            ...item,
            saasOrgId: item.orgId,
          }));
        setOrgByUserData(uniqueData);

        const arr: any = [{ orgName: "All", orgId: "All" }, ...uniqueData];
        dispatch({
          type: actionTypes.LOAD_COMPANYNAMES_SUCCESS,
          payload: arr,
        });
      }
    } catch (error: any) {
      showToast("ERROR", error.response.data.errorMessage);
    }
  };

  return (
    <div className="dropdown d-inline-block user-dropdown" ref={wrapper}>
      <button
        type="button"
        className="btn user-dp header-item d-flex"
        id="page-header-user-dropdown"
        data-bs-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        onClick={(e: any) => {
          setOpen("show");
        }}
      >
        <OrgImage />
        <div className="d-flex flex-column">
          <div className="d-inline-block">
            <span className="d-none d-xl-inline-block ms-1 font-size-12">
              {username}
            </span>
            <i className="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </div>
          <div>
            <div
              className="username d-none d-xl-block ms-1 font-size-9"
              style={{
                lineHeight: "0.6rem",
                textAlign: "left",
                overflow: "hidden",
                height: "20px",
                top: "30px",
              }}
            >
              {`${userFirstName} ${userLastName}`}
            </div>
          </div>
        </div>
      </button>

      <div
        className={`dropdown-menu dropdown-menu-end ${open}`}
        style={{ cursor: "pointer" }}
      >
        <a className="dropdown-item" onClick={onClickProfile}>
          <i className="ri-user-line align-middle me-1"></i>
          {getMessageText(LangConst.PROFILE, "Profile  ")}
        </a>
        <div className="dropdown-divider"></div>

        <a
          className="dropdown-item"
          style={{ paddingLeft: "2px" }}
          onClick={() => setIsLangDropDrown(!isLangDropDrown)}
        >
          {!isLangDropDrown ? (
            <i className="ri-arrow-down-s-fill align-middle mx-1"></i>
          ) : (
            <i className="ri-arrow-left-s-fill align-middle mx-1"></i>
          )}
          <i className="ri-translate align-middle me-2"></i>
          {language}
        </a>
        {isLangDropDrown && (
          <div
            style={{
              position: "absolute",
              right: "100%",
              top: "23%",
              backgroundColor: "#fff",
              zIndex: 9999999,
              boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
            }}
          >
            {languages.map((lang) => (
              <a
                key={lang}
                className="dropdown-item"
                onClick={() => handleLanguageChange(lang)}
              >
                {lang}
              </a>
            ))}
          </div>
        )}

        <div className="dropdown-divider"></div>
        <a className="dropdown-item" onClick={onChangePassword}>
          <i className="ri-lock-line align-middle me-1"></i>
          {getMessageText(LangConst.CHANGE_PASSWORD, "Change Password ")}
        </a>

        {saasOrgId === "1" || orgByUserData?.length > 1 ? (
          <>
            <div
              className="dropdown-divider"
              //EXTERNAL CHILD CONTROLLER TO HIDE SWITCH ORGANIZATION
              //style={window.opener ? { display: "none" } : {}}
            ></div>
            <a
              className="dropdown-item"
              onClick={(e) => onSwitchUser(e)}
              //EXTERNAL CHILD CONTROLLER TO HIDE SWITCH ORGANIZATION
              //style={window.opener ? { display: "none" } : {}}
            >
              <i className="ri-user-line align-middle me-1"></i>
              {getMessageText(
                LangConst.SWITCH_ORGANIZATION,
                "Switch Organization "
              )}
            </a>
          </>
        ) : null}
        <div
          className="dropdown-divider"
          //EXTERNAL CHILD CONTROLLER TO HIDE LOGOUT
          //style={window.opener ? { display: "none" } : {}}
        ></div>
        <a
          //EXTERNAL CHILD CONTROLLER TO HIDE LOGOUT
          //style={window.opener ? { display: "none" } : {}}
          className="dropdown-item text-danger"
          onClick={() => handleLogout(navigate)}
        >
          <i className="ri-shut-down-line align-middle me-1 text-danger"></i>{" "}
          {getMessageText(LangConst.LOGOUT, "Logout ")}
        </a>
      </div>
      <SwitchOrganization
        show={openSwitch}
        onCancelDialogue={onHandleClose}
        orgByUserData={orgByUserData}
      />
      <ChangePassword
        show={openChangePassword}
        onCancelDialogue={onHandleClose}
      />
      <ProfileDialog show={openProfile} onCancelDialogue={onHandleClose} />
    </div>
  );
};
